import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row font-bold text-center w-full items-stretch text-base mb-2 2xl:mb-4"
}
const _hoisted_2 = { class: "flex flex-col w-1/4" }
const _hoisted_3 = { class: "countdown-amount days" }
const _hoisted_4 = { class: "flex flex-col w-1/4" }
const _hoisted_5 = { class: "countdown-amount hours" }
const _hoisted_6 = { class: "flex flex-col w-1/4" }
const _hoisted_7 = { class: "countdown-amount minutes" }
const _hoisted_8 = { class: "flex flex-col w-1/4" }
const _hoisted_9 = { class: "countdown-amount seconds" }

import {useStore} from "../store";
import {reactive, onMounted, onUnmounted, watch} from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'CountdownComponent',
  props: {
    startTime: {}
  },
  emits: ["ended"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit;
const store = useStore();
const state = reactive({days: 0, hours: 0, minutes: 0, seconds: 0, visible: false})
let CT_TIMER: number | null = null;
const randTime = (Math.floor(Math.random() * 49) + 12) * 1000;
let airTime = new Date(props.startTime as string).getTime() + randTime;

function calculateTime(){
    const currentTime = new Date().getTime();
    if (currentTime > airTime){
        store.updateItemVersion();
        if (CT_TIMER){
            clearInterval(CT_TIMER);
        }
        state.visible = false
        emit("ended")
    }else{
        if (!state.visible){
            state.visible = true
        }
    }

    const secondsLeft = (airTime - currentTime) / 1000;
    state.days = Math.floor(secondsLeft / 86400);
    state.hours = Math.floor((secondsLeft % 86400) / 3600);
    state.minutes = Math.floor(((secondsLeft % 86400) % 3600) / 60);
    state.seconds = Math.floor(((secondsLeft % 86400) % 3600) % 60)
}

onMounted(() => {
    calculateTime()
    CT_TIMER = setInterval(calculateTime, 1000);
})

onUnmounted(() => {
    if (CT_TIMER){
        clearInterval(CT_TIMER);
        state.visible = false
    }
})

watch(() => props.startTime, (startTime) => {
    airTime = new Date(startTime as string).getTime()  + randTime;
})

return (_ctx: any,_cache: any) => {
  return (state.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(state.days), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-tf7" }, "DAYS", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(state.hours), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-tf7" }, "HOURS", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(state.minutes), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-tf7" }, "MINS", -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(state.seconds), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-tf7" }, "SEC", -1))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})